// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2RJ_2","content":"styles_content__3KhPa","selectAll":"styles_selectAll__4YiaW"};